
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#052420","d":"M31.2 20.82c-2.03-5.01-6.17-9.12-11.72-10.92C12.75 7.71 5.68 9.5.8 13.96c.68 2.12 2.02 3.98 4.01 5.58 5.2 4.19 14 4.61 26.39 1.28z"}})])
      }
    
      }
    